import React from "react";
import { Navigate } from "react-router-dom";
import { getCachedClientFeatures } from "../lib/api";
import { getFirstEnabledClientRoute, isClientFeatureEnabled } from "../lib/clientFeatures";

export default function FeatureRoute({ feature, children }) {
  const role = localStorage.getItem("role");
  if (role === "admin") return children;

  const features = getCachedClientFeatures();
  if (isClientFeatureEnabled(feature, features)) return children;

  return <Navigate to={getFirstEnabledClientRoute(features)} replace />;
}

